<div>
  <h4 class="text-dark" [ngClass]="'text-'+labelPosition">{{ title | translate : params }}</h4>
  <img *ngIf="icon" class="mt-5 no-data-icon" [src]="'assets/img/' + icon + '.svg'" alt="no-data">
  <p class="mt-4 text-dark font-weight-bold subtitle" [innerHtml]="subtitle | translate : params"></p>
  <p [innerHtml]="content | translate : params"></p>
  <ng-content></ng-content>
</div>
